import { UPDATE_CURRENCY } from "app/reducers/currencyActionTypes";

export const updateCurrency = currencyCode => {
	return {
		type: UPDATE_CURRENCY,
		currencyCode,
	};
};
